export function getMyRoles(schedule) {
      const roles = []
      const userId = parseInt(this.currentUserId)
      
      if (!userId || !schedule) return roles
      
      // Check inspectors
      if (schedule.inspectors && schedule.inspectors.includes(userId)) {
        roles.push('Technician')
      }
      
      // Check correction team
      if (schedule.correction_team && schedule.correction_team.includes(userId)) {
        roles.push('Correction')
      }
      
      // Check corrective action team
      if (schedule.corrective_action_team && schedule.corrective_action_team.includes(userId)) {
        roles.push('Corrective Action')
      }
      
      // Check verification team
      if (schedule.verification_team && schedule.verification_team.includes(userId)) {
        roles.push('Verification')
      }

      if (schedule.action_team && schedule.action_team.includes(userId)) {
        roles.push('Action')
      }

      if (schedule.post_inspection_team && schedule.post_inspection_team.includes(userId)) {
        roles.push('Post Inspection')
      }
      
      return roles
    }